import styled from 'styled-components';

import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';

import { FONT_SIZES, PALETTE } from '~/assets/styles/base';

export const StyledTableHeadRow = styled(TableRow)`
  background: ${PALETTE.white};
`;

type StyledTableCellProps = {
  $bgColored?: boolean;
  $isShowTargetSampleWarning?: boolean;
  $colored?: boolean;
};
export const StyledTableCell = styled(TableCell)<StyledTableCellProps>`
  text-align: center;
  background: ${(props) => (props.$bgColored ? PALETTE.primary.superLight : 'inherit')};
  background: ${(props) => props.$isShowTargetSampleWarning && PALETTE.warning.light};
  border: 1px solid ${PALETTE.border.table};
  font-size: ${FONT_SIZES.bodyDefault};
  color: ${(props) => (props.$colored ? PALETTE.text.primary : PALETTE.text.main)};
  // tableCellのバリデーションエラーで表示被りが発生しないように調整
  .MuiTooltip-popper[data-popper-placement*='top'] .MuiTooltip-tooltip {
    margin-bottom: 0;
    div[color='error'] {
      padding: 7px 15px;
    }
  }
`;

type StyledTableBodyRowProps = {
  $index?: number;
};
export const StyledTableBodyRow = styled(TableRow)<StyledTableBodyRowProps>`
  background: ${(props) =>
    props.$index !== undefined && props.$index % 2 === 0 ? PALETTE.bg.main : PALETTE.white};
`;
